(function() {
  'use strict';
  // "Mon Look" — plateau flottant qui accumule des produits pendant la navigation
  // (localStorage, persiste entre les pages), puis ajoute tout au panier en un clic.
  // Créé 2026-07-02 — complète le conseiller IA (qui construit un look en un appel)
  // avec un parcours manuel (la cliente compose elle-même en visitant les fiches produit).

  var STORAGE_KEY = 'lsdl_mon_look';
  var isOpen = false;

  function getLook() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveLook(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    render();
  }

  // ── CSS ──────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = `
    #look-tray-btn {
      position: fixed; bottom: 24px; left: 24px; z-index: 9997;
      background: #000; color: #fff; border: none; border-radius: 30px;
      padding: 12px 20px 12px 16px; display: none; align-items: center; gap: 8px;
      cursor: pointer; font-size: 13px; font-family: inherit; font-weight: 700;
      box-shadow: 0 4px 20px rgba(0,0,0,.25); transition: transform .15s;
    }
    #look-tray-btn:hover { transform: translateY(-2px); }
    #look-tray-icon { font-size: 16px; }
    #look-tray-count {
      background: #E53935; color: #fff; border-radius: 50%; width: 20px; height: 20px;
      display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 800;
    }
    #look-tray-panel {
      position: fixed; bottom: 90px; left: 24px; z-index: 9998; width: 300px; max-height: 440px;
      background: #fff; border-radius: 12px; box-shadow: 0 12px 48px rgba(0,0,0,.2);
      display: none; flex-direction: column; overflow: hidden; font-family: inherit;
    }
    #look-tray-panel.open { display: flex; }
    #look-tray-header { padding: 14px 16px; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: center; }
    #look-tray-title { font-size: 13px; font-weight: 800; }
    #look-tray-close { background: none; border: none; font-size: 16px; cursor: pointer; opacity: .5; }
    #look-tray-items { flex: 1; overflow-y: auto; padding: 8px 12px; max-height: 260px; }
    .look-item { display: flex; gap: 10px; align-items: center; padding: 8px 0; border-bottom: 1px solid #f5f5f5; }
    .look-item img { width: 44px; height: 44px; object-fit: cover; border-radius: 4px; background: #f0f0f0; flex-shrink: 0; }
    .look-item-info { flex: 1; min-width: 0; }
    .look-item-title { font-size: 11.5px; font-weight: 700; line-height: 1.3; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .look-item-price { font-size: 11px; color: #999; }
    .look-item-remove { background: none; border: none; color: #ccc; cursor: pointer; font-size: 14px; padding: 4px; }
    .look-item-remove:hover { color: #E53935; }
    #look-tray-empty { padding: 30px 16px; text-align: center; font-size: 12px; color: #999; }
    #look-tray-footer { padding: 12px 16px; border-top: 1px solid #eee; }
    #look-tray-checkout {
      width: 100%; background: #000; color: #fff; border: none; padding: 12px; border-radius: 4px;
      font-size: 12px; font-weight: 800; letter-spacing: .5px; text-transform: uppercase; cursor: pointer;
    }
    #look-tray-checkout:hover { background: #E53935; }
    #look-tray-checkout:disabled { opacity: .5; cursor: wait; }
    #look-tray-clear { display: block; text-align: center; font-size: 10.5px; color: #999; margin-top: 8px; cursor: pointer; text-decoration: underline; }
    .look-add-toast {
      position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); background: #000; color: #fff;
      padding: 10px 20px; border-radius: 4px; font-size: 12px; z-index: 99999; font-family: inherit;
    }
    @media (max-width: 480px) { #look-tray-panel { width: calc(100vw - 24px); left: 12px; } #look-tray-btn { left: 12px; bottom: 16px; } }
  `;
  document.head.appendChild(style);

  // ── HTML ─────────────────────────────────────────────────
  var wrap = document.createElement('div');
  wrap.innerHTML = `
    <button id="look-tray-btn" aria-label="Mon look">
      <span id="look-tray-icon">🛍️</span> Mon look <span id="look-tray-count">0</span>
    </button>
    <div id="look-tray-panel" role="dialog" aria-label="Mon look">
      <div id="look-tray-header">
        <div id="look-tray-title">Mon look en construction</div>
        <button id="look-tray-close" aria-label="Fermer">✕</button>
      </div>
      <div id="look-tray-items"></div>
      <div id="look-tray-footer">
        <button id="look-tray-checkout">Ajouter tout au panier</button>
        <span id="look-tray-clear">Vider ma sélection</span>
      </div>
    </div>
  `;
  document.body.appendChild(wrap);

  var btn = document.getElementById('look-tray-btn');
  var panel = document.getElementById('look-tray-panel');
  var countEl = document.getElementById('look-tray-count');
  var itemsEl = document.getElementById('look-tray-items');
  var closeBtn = document.getElementById('look-tray-close');
  var checkoutBtn = document.getElementById('look-tray-checkout');
  var clearBtn = document.getElementById('look-tray-clear');

  function money(n) { return n == null ? '—' : (Math.round(parseFloat(n) * 100) / 100).toFixed(2); }

  function render() {
    var items = getLook();
    btn.style.display = items.length ? 'flex' : 'none';
    countEl.textContent = items.length;
    if (!items.length) {
      itemsEl.innerHTML = '<div id="look-tray-empty">Ajoutez des articles en parcourant la boutique pour composer votre look.</div>';
      checkoutBtn.disabled = true;
      return;
    }
    checkoutBtn.disabled = false;
    itemsEl.innerHTML = items.map(function(it, i) {
      return '<div class="look-item">' +
        (it.image ? '<img src="' + it.image + '">' : '<div style="width:44px;height:44px;background:#f0f0f0;border-radius:4px;flex-shrink:0;"></div>') +
        '<div class="look-item-info"><div class="look-item-title">' + it.title + '</div><div class="look-item-price">CHF ' + money(it.price) + '</div></div>' +
        '<button class="look-item-remove" data-idx="' + i + '">✕</button>' +
      '</div>';
    }).join('');
    itemsEl.querySelectorAll('.look-item-remove').forEach(function(b) {
      b.addEventListener('click', function() {
        var items2 = getLook();
        items2.splice(parseInt(b.dataset.idx, 10), 1);
        saveLook(items2);
      });
    });
  }

  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'look-add-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function() { t.remove(); }, 2000);
  }

  // API publique — appelée par le bouton "Ajouter à mon look" sur les fiches produit
  window.LSDLMonLook = {
    add: function(item) {
      // item: { variant_id, title, price, image }
      var items = getLook();
      if (items.some(function(i) { return i.variant_id === item.variant_id; })) {
        showToast('Déjà dans votre look');
        return;
      }
      items.push(item);
      saveLook(items);
      showToast('✓ Ajouté à mon look');
    },
    count: function() { return getLook().length; }
  };

  btn.addEventListener('click', function() {
    isOpen = !isOpen;
    panel.classList.toggle('open', isOpen);
  });
  closeBtn.addEventListener('click', function() { isOpen = false; panel.classList.remove('open'); });
  clearBtn.addEventListener('click', function() { saveLook([]); });

  checkoutBtn.addEventListener('click', function() {
    var items = getLook();
    var lineItems = items.filter(function(i) { return i.variant_id; }).map(function(i) { return { id: parseInt(i.variant_id, 10), quantity: 1 }; });
    if (!lineItems.length) return;
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    })
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function() {
        saveLook([]);
        window.location.href = '/cart';
      })
      .catch(function() { showToast('Erreur — certains articles indisponibles'); checkoutBtn.disabled = false; checkoutBtn.textContent = 'Ajouter tout au panier'; });
  });

  render();
})();
